import React, { useCallback, useEffect, useState } from "react";
import styles from "./styles.module.css";
import DefaultAvatarNx from "../../../assets/svgs/gameplay/DefaultAvatarNx";
import InfoIcon from "../../../assets/svgs/InfoIcon";
import { getWidth } from "../../../utils/relativeSizes";
import { COLOR_WHITE } from "../../../assets/colors";
import clsx from "clsx";
import SkipTooltip from "./SkipTooltip";
import { _isEmpty } from "../../../utils/helpers/zupeeLodash";
import { useSelector } from "react-redux";
import { getIsSkipTooltipVisible, getNxUserInfoData, getTst } from "../../../store/selectors/ludoboardSelectors";
import { store } from "../../../store";
import { getProfilePicture2P, setIsSkipTooltipVisible } from "../../../store/actions/ludoboardActions";
import { useTranslation } from "react-i18next";

const UserInfo: React.FC = () => {
  const {t} = useTranslation();
  const [isError, setIsError] = useState<boolean>(false)
  const [userImgUrl, setUserImgUrl] = useState()
  const userInfoData = useSelector(getNxUserInfoData)
  const tst = useSelector(getTst)

  const { profilePic } = (userInfoData as { profilePic?: string }) ?? {}

  const onSkipToolTipPress = useCallback(() => {
    const isSkipTooltipVisible = getIsSkipTooltipVisible(store.getState())
    if (isSkipTooltipVisible) {
      setIsSkipTooltipVisible(false)
    }
    else {
      setIsSkipTooltipVisible(true)
    }
  }, [])

  useEffect(() => {
    async function getImage(){
      const zupeeProfilePic = await getProfilePicture2P(profilePic)
      setUserImgUrl(zupeeProfilePic as any)
    }
    getImage()
  }, [profilePic])

  if (_isEmpty(userInfoData)) {
    return null
  }

  return (
    <>
      {/* User Avatar */}
      <div
        className={clsx(styles.avatarContainer, "flex alignItemCenter justifyContentCenter  absolute")}
        style={{ transform: `translate(${getWidth(-104)}px, ${getWidth(94)}px)` }}
      >
        {userImgUrl && !isError ? (
          <img
            src={userImgUrl}
            alt="User Avatar"
            className={clsx(styles.avatarImage)}
            onError={() => setIsError(true)}
            style={{ height: getWidth(56), width: getWidth(56), borderRadius: 30 }}
          />
        ) : (
          <DefaultAvatarNx height={getWidth(58)} width={getWidth(58)} />
        )}
      </div>

      {/* Tooltip Section */}
      <div
        className={clsx(styles.tooltipContainer, "absolute flex alignItemCenter justifyContentCenter")}
        onClick={onSkipToolTipPress}
        style={{
          transform: `translate(${getWidth(-104)}px, ${getWidth(164)}px)`,
          cursor: tst === "TST_ROUND_STARTED" ? "pointer" : "not-allowed",
        }}
      >
        <div className={clsx(styles.tooltipText, "fontSizeXs fontWeightBold fontColorWhite textUppercase")}>{t("you")}</div>
        <div className={clsx(styles.tooltipIconWrapper, "relative")}>
          <InfoIcon width={getWidth(12)} height={getWidth(12)} fillColor={COLOR_WHITE} />
          <SkipTooltip />
        </div>
      </div>
    </>
  );
};

export default UserInfo;